export default __webpack_public_path__ + "static/media/filter_icon_garden_blue.9c4361a5.svg";